import { initialState, newMedicationSchedule } from './state';

export function setDSSMedicationSchedules(state, DSSMedicationSchedules) {
  Object.assign(state, { DSSMedicationSchedules });
}

export function reset(state) {
  Object.assign(state, initialState());
}

export function addMedicationSchedule(state) {
  const DSSMedicationSchedules = state.DSSMedicationSchedules
    .map((DSSMedicationSchedule, index) => {
      if (index === 0) {
        return Object.assign(DSSMedicationSchedule, {
          medicationSchedules: [
            ...DSSMedicationSchedule.medicationSchedules,
            newMedicationSchedule(),
          ],
        });
      }

      return DSSMedicationSchedule;
    });

  Object.assign(state, { DSSMedicationSchedules });
}

export function removeMedicationSchedule(state, index) {
  const DSSMedicationSchedules = state.DSSMedicationSchedules
    .map((DSSMedicationSchedule, i) => {
      if (i === 0) {
        Object.assign(DSSMedicationSchedule, {
          medicationSchedules: DSSMedicationSchedule.medicationSchedules
            .filter((currentItem, j) => j !== index),
        });
      }

      return DSSMedicationSchedule;
    });

  Object.assign(state, { DSSMedicationSchedules });
}

export function updateMedicationSchedule(state, { index, medicationSchedule }) {
  const DSSMedicationSchedules = state.DSSMedicationSchedules
    .map((DSSMedicationSchedule, i) => {
      if (i === 0) {
        Object.assign(DSSMedicationSchedule, {
          medicationSchedules: DSSMedicationSchedule.medicationSchedules
            .map((currentItem, j) => {
              if (j === index) {
                return medicationSchedule;
              }

              return currentItem;
            }),
        });
      }

      return DSSMedicationSchedule;
    });

  Object.assign(state, { DSSMedicationSchedules });
}

export function setMedicaitonClasses(state, medicationClasses) {
  Object.assign(state, { medicationClasses });
}

export function setPatientQuestionnaires(state, patientQuestionnaires) {
  Object.assign(state, { patientQuestionnaires });
}

export function setAuditTrails(state, auditTrails) {
  Object.assign(state, { auditTrails });
}

export function setPrescriptionRecentlyUpdatedWarning(state, updated) {
  Object.assign(state, { prescriptionRecentlyUpdatedWarning: updated });
}

export function setSchedulesToBeDeleted(state, count) {
  Object.assign(state, { schedulesToBeDeleted: count });
}

export function setDSSFirstLoad(state, DSSFirstLoad) {
  Object.assign(state, { DSSFirstLoad });
}

export function setDSSLastAuditTrails(state, DSSLastAuditTrails) {
  Object.assign(state, { DSSLastAuditTrails });
}

export function removeUnhandledMedicationRecommendationById(state, medicationRecommendationId) {
    const unhandledMedicationRecommendations = state?.DSSMedicationSchedules.length ?
        state.DSSMedicationSchedules[0].algorithm?.unhandledMedicationRecommendations : null;

    if (unhandledMedicationRecommendations && unhandledMedicationRecommendations.length) {
        for (let i=0; i<unhandledMedicationRecommendations.length; i++) {
            if (medicationRecommendationId === unhandledMedicationRecommendations[i].id) {
                unhandledMedicationRecommendations.splice(i, 1);
                Object.assign(state.DSSMedicationSchedules[0].algorithm, { unhandledMedicationRecommendations });
                return;
            }
        }
    }
}